export default defineNuxtRouteMiddleware(async (to, from) => {
  const caseStore = useCaseStore()

  if (to.path === '/') {
    return navigateTo('/dashboard')
  }

  if(to.path === '/case' && caseStore.selectedCase?.regNum) {
    return navigateTo(`/case/${caseStore.selectedCase.regNum }`)
  }
})
